module.exports = __webpack_public_path__ + "static/fipcnavyteddy2-9d9e71ba76112e0bd0ca7145e22c966f.jpeg";